import { ref } from "vue";

/**
 * Whether the session this app was using has lapsed.
 *
 * Module-level rather than per-component: a session dies once, for the whole
 * app, and every screen has to react the same way. A component-local flag would
 * mean whichever screen happened to make the failing call owns the message.
 */
export const sessionExpired = ref(false);

/**
 * Announce that the session is gone.
 *
 * Deliberately separate from redirecting. Redirecting is the right response on a
 * page that needs a session; it is the WRONG response on a public one — the
 * player lobby is browsable signed out, so throwing a visitor to /login for
 * clicking Deposit is worse than telling them what happened. But "do not
 * redirect" was previously implemented as "do nothing", which is how a lapsed
 * session turned into buttons that quietly stopped working.
 */
export function markSessionExpired() {
  sessionExpired.value = true;
}

export function clearSessionExpired() {
  sessionExpired.value = false;
}
